import colors from 'material-colors';

import { DEFAULT_GEO_COLUMN_KEY } from 'uf/layers/geometryKey';
import {
  CuratedColumnSymbology,
  InterpolationTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/california_lqls_uneval_area': {
    [DEFAULT_GEO_COLUMN_KEY]: [
      {
        type: SymbologyTypes.FILL,
        paint: {
          'fill-color': colors.yellow[500],
          'fill-opacity': 0.5,
        },
        display_hints: {
          scale: SymbologyScales.CATEGORICAL,
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          theme: 'material:yellow:500',
        },
      },
    ],
  },
};

export default symbologies;
